import { Settings, Help, Notifications, ExitToApp } from '@material-ui/icons';
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import setAuthToken from '../../../utils/setAuthToken';
import { useNavigate } from 'react-router';
import swal from 'sweetalert';
import { Switch } from '@material-ui/core';
function displayToast() {
    // display alert message for 1.5 sec
    swal({
        title: 'You do not have permission to access this page',
        icon: 'warning',
        timer: 1500
    });
}
const Navbar = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [applicableAnchorEl, setApplicableAnchorEl] = React.useState<null | HTMLElement>(null);
    const [checked, setChecked] = useState<boolean>(localStorage.getItem('showApplicableOnly') == '1');

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
        setApplicableAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setApplicableAnchorEl(null);
    };

    const navigate = useNavigate();
    const userStr = localStorage.getItem('user');
    let user = null as { user_info: { role: string; id: number }; access_token: string } | null;
    if (userStr) user = JSON.parse(userStr);
    return (
        <nav className="d-flex justify-content-end align-items-center py-1 px-3" style={{ backgroundColor: '#F1F3F5' }}>
            <Notifications
                cursor="pointer"
                onClick={() =>
                    (user && user.user_info.role === 'Customer Admin') ||
                    (user && user.user_info.role === 'Customer User')
                        ? navigate(`/tasks/${user.user_info.id}`)
                        : displayToast()
                }
            />
            <Help
                className="ms-3"
                cursor="pointer"
                onClick={() => (user && user.user_info.role === 'SysAdmin' ? navigate('/change-logs') : displayToast())}
            />
            <IconButton
                className="ms-3"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick2}
            >
                <Settings style={{ fill: 'black' }} />
            </IconButton>
            {/* && (window.location.pathname === `/library/${row.id}`) */}
            {((user && user.user_info.role === 'Customer Admin') ||
                (user && user.user_info.role === 'Customer User')) && (
                <Menu
                    id="basic-menu"
                    anchorEl={applicableAnchorEl}
                    open={Boolean(applicableAnchorEl)}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button2'
                    }}
                    PaperProps={{
                        sx: {
                            overflow: 'visible',
                            mt: 1.5,
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 80, // adjust this based on the icon position
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0
                            }
                        }
                    }}
                >
                    <MenuItem onClick={() => {}}>
                        Applicable Rules
                        <Switch
                            size="small"
                            color="primary"
                            checked={checked}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                const value = event.target.checked;
                                setChecked(value);
                                localStorage.setItem('showApplicableOnly', value ? '1' : '0');
                                // Trigger storage event manually
                                window.dispatchEvent(new Event('storage'));
                            }}
                        />
                    </MenuItem>
                </Menu>
            )}
            <IconButton
                className="ms-3"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <Avatar />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button'
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleClose();
                        navigate('/profile');
                    }}
                >
                    Profile <Avatar sx={{ width: 24, height: 24 }} className="ms-2" />
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        localStorage.removeItem('user');
                        setAuthToken(false);
                        navigate('/');
                    }}
                >
                    {' '}
                    Logout <ExitToApp className="ms-2" />
                </MenuItem>
            </Menu>
        </nav>
    );
};

export default Navbar;
